
import axios, { AxiosResponse } from "axios";
import { Component, Prop, Vue } from "vue-property-decorator";
import GlobalConfig from "@/GlobalConfig";
import UmbracoApiService from "@/services/UmbracoApiService";
import WsdlService from "@/services/WsdlService";
import FundTypeObj from "@/models/WsdlResponses/FundTypeObj";
import Swal from "sweetalert2";
import ServicioNotificacionBalanceModel, {
    UserBalanceModel,
} from "@/models/ServicioNotificacionBalance/ServicioNotificacionBalanceModel";
import AfiliadoService from "@/services/AfiliadoService";

@Component({})
export default class NotificationAportesResult extends Vue {
    @Prop() tipoFondo: FundTypeObj;
	public afiliadoService: AfiliadoService = new AfiliadoService();
	public name: string = `${this.$store.state.user.primerNombre} ${this.$store.state.user.primerApellido}`;
	public isEmailNotification: boolean = false;
	public isCelNotification: boolean = false;
    public wsdlService: WsdlService = new WsdlService();

    public days: number[] = [];

    constructor() {
        super();
    }
    public async procesar() {
		let ip = (await this.afiliadoService.getUserIpAddress()).data.ip;
		let email = this.tipoFondo.tipofondos.emailusuario + '@' + this.tipoFondo.tipofondos.emailservidor;
		//ip: string, account: string, fundType: string, activate
		if(this.isEmailNotification) this.wsdlService.postNotificacionAporteCel(ip, this.tipoFondo.tipofondos.codcuenta.toString(), this.tipoFondo.tipofondos.valor, true);
		if(this.isCelNotification) this.wsdlService.postNotificacionAporteEmail(ip, this.tipoFondo.tipofondos.codcuenta.toString(), this.tipoFondo.tipofondos.valor, this.name, email,  true);
		this.$emit('nextStep');
		this.$emit('updateNotificationData', this.isEmailNotification, this.isCelNotification);
	}
    returnHome() {
		this.$emit('returnHome');
    }
	public updateUser(){
		this.$emit('updateUser');
	}

    async mounted() {
        for (let index = 0; index <= 31; index++) {
            this.days.push(index);
        }
        this.isEmailNotification = this.tipoFondo.tipofondos.balancexmail === '1';
		this.tipoFondo.tipofondos.balancexcelular === '1';
    }
}
